import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/content';

export default function SiteNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled || menuOpen
          ? 'bg-white/95 backdrop-blur border-b border-stone-200'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full flex items-center justify-between gap-4 px-4 md:px-8 h-16">
        <a href="#top" className="flex items-center gap-2 shrink-0">
          <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-orange-500 text-white">
            <i className="ri-movie-2-line text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-lg md:text-xl font-bold text-stone-900 whitespace-nowrap">
            蜜桃成熟时<span className="text-orange-500">3D</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1" aria-label="页面分区导航">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className="px-3 py-2 rounded-md text-sm text-stone-600 hover:text-orange-600 hover:bg-orange-100/70 transition-colors whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block shrink-0">
          <a
            href="#online"
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-orange-500 text-white text-sm font-medium hover:bg-orange-600 transition-colors whitespace-nowrap"
          >
            查看观看思路
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-stone-700 hover:bg-orange-100/70 cursor-pointer"
          aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
          aria-expanded={menuOpen}
        >
          <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'} aria-hidden="true"></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-stone-200 bg-white">
          <nav className="px-4 py-3 flex flex-col gap-1" aria-label="移动端分区导航">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-2.5 rounded-md text-sm text-stone-700 hover:bg-orange-100/70 hover:text-orange-600 transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#online"
              onClick={() => setMenuOpen(false)}
              className="mt-1 px-3 py-2.5 rounded-md bg-orange-500 text-white text-sm font-medium text-center"
            >
              查看观看思路
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}